import React, { Component } from 'react';
import JobsTable from '../jobs/jobs-table.jsx';
export default class CustomersJobsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: props.url || null,
      jobs:[],
      isLoading:true,
      hasMore:true,
      page:1
    };
    this.handleScroll = this.handleScroll.bind(this);
  }
  componentDidMount() {
    if (this.state.isLoading) {
      this.getCustomerJobs();
    }
  }
  componentWillMount() {
      window.addEventListener(
        'scroll',
        this.handleScroll
      );
  }
  handleScroll() {
    if ((window.innerHeight + document.scrollingElement.scrollTop + 10
        ) >= document.documentElement.offsetHeight) {
          if(this.state.hasMore){
            this.setState({
              isLoading: true
            });
            this.getCustomerJobs();
            }
    }
  }
  getCustomerJobs(filterby = null) {
    let url = this.state.url + '?page=' + this.state.page;
  
    if (filterby != null || this.state.filterByC) {
      url += '&filterby=' + (filterby || this.state.filterByC);
    }
  
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token,
        "Accept": 'application/json'
      }
    }).then((responseText) => {
      let response = responseText.json();
      response.then((dataJson) => {
        if (dataJson.jobs.data.length === 0) {
          this.setState({ hasMore: false });
        }
  
        // Check if it's a new filter; if yes, replace the jobs state
        this.setState((prevState) => ({
          jobs: this.state.page === 1 ? dataJson.jobs.data : [...prevState.jobs, ...dataJson.jobs.data],
          isLoading: false,
          page: dataJson.jobs.current_page + 1
        }));
      });
    });
  }
  handleFilterBySelectedMove(e) {
    let filterBy = e.target.value;
    this.setState(
      { page: 1, jobs: [], isLoading: true, filterByC: filterBy, hasMore: true },
      () => {
        this.getCustomerJobs(filterBy);
      }
    );
  }
  render() {
    return (
      <div className="col-md-12">
        <div className="col-md-2 text-center mrgn-btm" style={{'margin':'0 auto'}}>
          <label>Filter by :</label> &nbsp;&nbsp;
          <select className="form-control form-control-lg" onChange={(e)=>this.handleFilterBySelectedMove(e)}>
            <option value="active">Active Moves</option>
            <option value="completed">Completed Moves</option>
          </select>
        </div>
        <h3>Customer Moves</h3>
        { (this.state.jobs.length > 0 )?
            <JobsTable
                url={this.state.url}
                jobs={this.state.jobs}
                noCategoryLabels={true}
                message_if_none='No Jobs found. Add one to see it here.'
                driverScreen={false}
                customerAllJobsPage={true}
            /> : null
        }
        {
          this.state.isLoading ?
          (<div className="loading-box" style={{margin:'0 auto'}}>
            <span className="add-loading-text">
              <i className="fa fa-spinner fa-pulse"></i>
            </span>
          </div>) :
            null
        }
        {(this.state.hasMore) ?
          null
          :
          <div className="text-center no-more">
            <h1>
              No more jobs.
            </h1>
          </div>
        }
      </div>
    );
  }
}
